import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'
import { GetPdfReportResponse } from 'api/interviewAPI'

type State = {
  pdfFile: Blob | null
} & Status

const initialState = {
  pdfFile: null,
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_INTERVIEW_PDF_REPORT_ASYNC,
    Actions.GET_INTERVIEW_PDF_REPORT_SUCCESS,
    Actions.GET_INTERVIEW_PDF_REPORT_FAIL,
    GetPdfReportResponse
  >,
): State => {
  switch (action.type) {
    case Actions.GET_INTERVIEW_PDF_REPORT_ASYNC:
    case Actions.GET_INTERVIEW_PDF_REPORT_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.GET_INTERVIEW_PDF_REPORT_SUCCESS: {
      return {
        ...state,
        ...action.status,
        pdfFile: action.payload,
      }
    }

    default:
      return state
  }
}
